import { marked } from "marked";

const replaceHTMLTags = (text) => {
  text = text.replace(/^##### (.*$)/gm, "<h5>$1</h5>");
  text = text.replace(/^#### (.*$)/gm, "<h4>$1</h4>");
  text = text.replace(/^### (.*$)/gm, "<h3><strong>$1</strong></h3>");
  text = text.replace(/^## (.*$)/gm, "<h2><strong>$1</strong></h2>");
  text = text.replace(/^# (.*$)/gm, "<h1><strong>$1</strong></h1>");
  text = text.replace(/^---$/gm, "<hr>");
  text = text.replace(/^- (.*$)/gm, "<li>$1</li>");
  text = text.replace(/(<li>.*<\/li>)/g, "<ul>$1</ul>");
  text = text.replace(/([^\n])\n([^\n])/g, "$1\n$2");
  text = text.replace(/\n/g, "<br>");
  text = text.replace(/\\n/g, "<br>");
  text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  return text;
};

export const convertMarkdownToHTML = (markdownText) => {
  const markdownText1 = replaceHTMLTags(markdownText);
  return marked(markdownText1);
};

export const getPlainTextLength = (richText) => {
  if (!richText) return 0;

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = richText;

  let plainText = tempDiv.textContent || tempDiv.innerText || "";

  plainText = plainText
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  plainText = plainText.replace(/\s+/g, " ").trim();

  return plainText.length;
};

export const DESCRIPTION_LIMITS = {
  PLAIN_TEXT: 400,
  RICH_TEXT: 4000,
  WARNING_THRESHOLD: 0.9,
};

export const checkTextLength = (richText, isRichText = true) => {
  const plainLength = getPlainTextLength(richText);
  const totalLength = isRichText ? richText.length : plainLength;
  const limit = isRichText
    ? DESCRIPTION_LIMITS.RICH_TEXT
    : DESCRIPTION_LIMITS.PLAIN_TEXT;

  return {
    plainTextLength: plainLength,
    totalLength: totalLength,
    isExceeded: plainLength > DESCRIPTION_LIMITS.PLAIN_TEXT,
    isNearLimit:
      plainLength >
      DESCRIPTION_LIMITS.PLAIN_TEXT * DESCRIPTION_LIMITS.WARNING_THRESHOLD,
    remainingChars: DESCRIPTION_LIMITS.PLAIN_TEXT - plainLength,
  };
};
